import React, { useEffect } from 'react';

// Higher-Order Component to scroll to top on mount or route change
const withScrollToTop = (WrappedComponent) => {
  const ScrollToTop = (props) => {
    useEffect(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);
    // eslint-disable-next-line react/jsx-props-no-spreading -- HOC must forward all props to wrapped component
    return <WrappedComponent {...props} />;
  };
  ScrollToTop.displayName = `WithScrollToTop(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return ScrollToTop;
};

export default withScrollToTop;
